import { ObjectService } from "namirasoft-core";
import { BaseCommand } from "./BaseCommand";

export class BaseNavigatorCommand extends BaseCommand
{
    private commands: { [name: string]: any };
    constructor(argv: string[], commands: { [name: string]: any })
    {
        super(argv);
        this.commands = commands;
    }
    override async getError()
    {
        let name = this.argv[0];
        if (!name)
            return "Argument was not provided.";
        return null;
    }
    override async exec()
    {
        let name = this.argv[0];
        let Command = this.commands[name];
        if (Command)
        {
            let argv = this.argv.slice(1);
            let command;
            if (ObjectService.isClass(Command))
                command = new Command(argv);
            else
                command = Command(argv);
            command.app = this.app;
            command.name = name;
            command.parent = this;
            await command.run();
        }
        else
            this.app.logger.error(`Error: command '${name}' was not found. Use "help" command to see all the available commands.`);
    }
    override help()
    {
        this.app.logger.info("List of avaiable commands are here:");
        for (let key of Object.keys(this.commands))
            this.app.logger.info("    - " + key);
    }
}